import { gql } from '@apollo/client';

export const SOURCES_QUERY = gql`
  query sources($showOld: Boolean!) {
    sources(showOld: $showOld) {
      totalHosts
      totalLogs
      hosts {
        attributes
        dashboards {
          name
          urlTemplate
        }
        ipAddress
        logFiles
        name
      }
      kubeClusters {
        controllers {
          name
          kind
          pods {
            name
          }
          labels
        }
        name
        dashboard {
          name
        }
      }
    }
  }
`;
